 function loadForm(elementId, contextPath){
	var inhtml = '<form id="' + elementId.substring(1) + '_risk_cal" action="#"  method="post">';
	var question_count = 0;
	contextPath = contextPath || "/wp-content/themes/first-citizens/assets/calculators/risk-profile/DataFile.json";

	$.getJSON(contextPath).done(function(data) {
		 inhtml += "<div id='errormsg'></div>";
		$.each( data.Questions, function( index, value ) {

			var choices = '<fieldset name="question" id="step' + (index + 1) + '"><legend>'+ value.question_header +'</legend><p>' + value.text + '</p>';

			$.each( value.answers, function( index2, value2 ) {
				choices += '<input type="radio"  name="question' + (index + 1) +'" value="' + value2.weight + '">' + value2.answer + '</input><br />';
			});
			question_count++;
			choices += '</fieldset>';
			inhtml += choices ;

		});

		inhtml += ' <button type="submit" id="submit1" class="wp-block-button__link">Submit</button></form>';
		inhtml += '<label id="results" style="display:none"></label>';
		$(elementId).html(inhtml);
		$(elementId + '_risk_cal').validate({
			rules: {

				question1:{ required: true },
				question2:{ required: true },
				question3:{ required: true },
				question4:{ required: true },
				question5:{ required: true },
				question6:{ required: true },
				question7:{ required: true },
				question8:{ required: true }
			},
			errorPlacement: function(error, element){

				$('#errormsg').append(error);
			},
			messages: {
				question1: "<label style='color:red'>Please make a selection...</label>",
				question2: "<label style='color:red'>Please make a selection...</label>",
				question3: "<label style='color:red'>Please make a selection...</label>",
				question4: "<label style='color:red'>Please make a selection...</label>",
				question5: "<label style='color:red'>Please make a selection...</label>",
				question6: "<label style='color:red'>Please make a selection...</label>",
				question7: "<label style='color:red'>Please make a selection...</label>",
				question8: "<label style='color:red'>Please make a selection...</label>"
			},
			submitHandler : function() {
				var results_hash = '';
				for (var i = 1; i <= question_count; i++) {
					results_hash += $('input[name=question'+ i +']:checked').val();
				}
				$(elementId + '_risk_cal').hide();

				$('#results').html(data.Answers[data.Results[results_hash]]);
				$('#results').show();

			}
		});
		$(elementId + '_risk_cal').quickWizard({
			 'breadCrumb': false,
			 'prevButton': '<button id="form-wizard-prev" class="wp-block-button__link has-background has-lightgray-background-color" type="button">Previous</button>',
			 'nextButton': '<button id="form-wizard-next" class="wp-block-button__link" type="button">Next</button>',
		});


	}).fail(function(){
			console.log('Error in Json File');
	});
}

export default loadForm;
